import axios from 'axios';
import Qs from 'qs';
import { QW_HOLDOVER_KDM_URL } from '../config';
import { getAccessToken } from '../util/helper';

const qwHoldoverKdm = axios.create({
  baseURL: QW_HOLDOVER_KDM_URL,
  responseType: 'json',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${getAccessToken()}`,
  },
  paramsSerializer(params) {
    return Qs.stringify(params, { arrayFormat: 'brackets' });
  },
});

export default qwHoldoverKdm;
